export default __webpack_public_path__ + "static/media/Inter-UI-Light-BETA.65f38d78.woff2";